/**
 * Given an array and an index, return true if the index is the last index of the array.
 * @param {number} index - The index of the current item in the array.
 * @param {unknown[]} arr - The array to check the index of.
 * @returns the index of the last element in the array.
 */
export const getIsLastIndex = (index: number, arr: unknown[]): boolean => {
  return index === arr.length - 1;
};
